import { stores } from '@kurtosys/app-start';
import { IManifest } from '@kurtosys/types/appsManager/index.js';
import { computed, observable } from 'mobx';

import { IComponentStyles } from '../../models/app/IComponentStyles.js';
import { IConfiguration } from '../../models/app/IConfiguration.js';
import { TStoreContext } from '../../models/index.js';

export abstract class InputStoreBase<TOptions, TComponentProps, TValue> extends stores.base.StoreBase<
	IConfiguration,
	IComponentStyles
> {
	public inputKey: string;
	public options: TOptions;
	public componentProps: TComponentProps;

	@observable public value: TValue;

	public abstract get hasData(): boolean;

	@computed
	get show(): boolean {
		return this.hasData;
	}

	constructor(
		storeContext: TStoreContext,
		manifest: IManifest,
		inputKey: string,
		options: TOptions,
		componentProps: TComponentProps,
	) {
		super(storeContext, manifest);
		this.inputKey = inputKey;
		this.options = options;
		this.componentProps = componentProps;
	}

	async initialize(callbacks?: Record<string, EventListener> | undefined) {
		await this.initializeItems();
	}
	abstract initializeItems(): Promise<void>;
	abstract initializeValue(): TValue | void;
}
